import { LegalLayout } from "@/components/LegalLayout";

export default function PrivacyPolicy() {
  return (
    <LegalLayout eyebrow="— Pravne informacije" title="Politika privatnosti" lastUpdated="prosinac 2025.">
      <p>
        Vaša privatnost nam je važna. Ovom Politikom privatnosti obavještavamo Vas o tome koje osobne podatke
        prikupljamo, u koju svrhu, na kojoj pravnoj osnovi te koja prava imate sukladno{" "}
        <strong>Općoj uredbi o zaštiti podataka (GDPR — EU 2016/679)</strong> i{" "}
        <strong>Zakonu o provedbi Opće uredbe o zaštiti podataka (NN 42/18)</strong>.
      </p>

      <h2>1. Voditelj obrade</h2>
      <p>
        Voditelj obrade osobnih podataka je <strong>La Maison by FP, obrt za frizerske usluge</strong>,
        vl. Filip Pitinac, Matije Gupca 6, 31400 Đakovo, OIB: 70763675453, MBO: 99228335.<br />
        Kontakt: <a href="mailto:lamaisonbyfp@gmail.com">lamaisonbyfp@gmail.com</a> · 091 612 7321.
      </p>

      <h2>2. Koje podatke prikupljamo</h2>
      <p>Prilikom korištenja stranice <em>lamaisonbyfp.com</em> i online rezervacija, prikupljamo sljedeće podatke:</p>
      <ul>
        <li><strong>Ime i prezime</strong> — radi identifikacije rezervacije;</li>
        <li><strong>Broj telefona</strong> — radi kontakta i potvrde termina;</li>
        <li><strong>E-mail adresa</strong> — radi slanja potvrde i podsjetnika;</li>
        <li><strong>Odabrana usluga, datum i vrijeme termina</strong>;</li>
        <li><strong>Napomena</strong> (opcionalno) — informacija koju nam Vi sami dostavljate (npr. tip kose, alergije);</li>
        <li><strong>Tehnički podaci</strong> — IP adresa, vrsta uređaja, datum pristupa (sigurnosno logiranje poslužitelja).</li>
      </ul>

      <h2>3. Svrha i pravna osnova obrade</h2>
      <dl>
        <dt>Obrada rezervacije i pružanje usluge</dt>
        <dd>Pravna osnova: izvršenje ugovora (čl. 6. st. 1. b) GDPR-a).</dd>
        <dt>Komunikacija s klijentom (potvrda, podsjetnik, otkazivanje)</dt>
        <dd>Pravna osnova: izvršenje ugovora.</dd>
        <dt>Vođenje evidencije rezervacija</dt>
        <dd>Pravna osnova: legitimni interes (čl. 6. st. 1. f) GDPR-a) — uredno poslovanje obrta.</dd>
        <dt>Sigurnost stranice i sprječavanje zlouporabe</dt>
        <dd>Pravna osnova: legitimni interes.</dd>
      </dl>

      <h2>4. Razdoblje čuvanja</h2>
      <p>
        Podatke o rezervaciji čuvamo najduže <strong>24 mjeseca</strong> od dana realizacije ili otkazivanja
        termina, nakon čega se brišu osim ako poseban propis (računovodstveni) ne nalaže duže čuvanje.
        Tehničke logove (IP) čuvamo do <strong>30 dana</strong>.
      </p>

      <h2>5. Primatelji podataka i prijenos trećim stranama</h2>
      <p>Vaše osobne podatke ne prodajemo niti ustupamo trećim stranama u marketinške svrhe. Koristimo sljedeće tehničke izvršitelje obrade:</p>
      <ul>
        <li><strong>Google LLC (Gmail SMTP)</strong> — za slanje e-mail potvrda rezervacije. <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">Google Privacy</a>.</li>
        <li><strong>Google LLC (Google Maps)</strong> — za prikaz lokacije salona u footeru.</li>
        <li><strong>MongoDB</strong> / <strong>Emergent</strong> — pohrana rezervacija na hostingu unutar EU.</li>
        <li><strong>Meta Platforms (Instagram embed)</strong> — link na profil; ne prenosi se ništa do dok ne kliknete.</li>
      </ul>
      <p>
        Ne vršimo prijenos osobnih podataka u treće zemlje izvan EU/EGP, osim u onoj mjeri u kojoj ga vrše
        navedeni izvršitelji obrade na temelju Standardnih ugovornih klauzula Europske komisije.
      </p>

      <h2>6. Vaša prava</h2>
      <p>Sukladno GDPR-u imate sljedeća prava koja možete ostvariti slanjem zahtjeva na e-mail iz točke 1.:</p>
      <ul>
        <li>Pravo na pristup svojim osobnim podacima;</li>
        <li>Pravo na ispravak netočnih podataka;</li>
        <li>Pravo na brisanje („pravo na zaborav&rdquo;);</li>
        <li>Pravo na ograničavanje obrade;</li>
        <li>Pravo na prenosivost podataka;</li>
        <li>Pravo na prigovor obradi temeljenoj na legitimnom interesu;</li>
        <li>Pravo na podnošenje prigovora nadzornom tijelu — <strong>Agencija za zaštitu osobnih podataka (AZOP)</strong>, Selska 136, 10000 Zagreb, <a href="https://azop.hr" target="_blank" rel="noreferrer">azop.hr</a>.</li>
      </ul>

      <h2>7. Sigurnost</h2>
      <p>
        Provodimo tehničke i organizacijske mjere zaštite (kriptirana komunikacija HTTPS, zaštita pristupa
        administraciji, sigurne lozinke) primjerene riziku obrade.
      </p>

      <h2>8. Maloljetnici</h2>
      <p>
        Online rezervacija namijenjena je osobama od navršenih 16 godina. Za rezervaciju usluge maloljetnoj
        osobi potrebna je suglasnost roditelja/skrbnika.
      </p>

      <h2>9. Izmjene politike</h2>
      <p>
        Zadržavamo pravo izmjena ove Politike. O značajnijim izmjenama bit ćete obaviješteni putem stranice.
        Datum posljednjeg ažuriranja naveden je na vrhu ove stranice.
      </p>
    </LegalLayout>
  );
}
